import _ from 'lodash';

/**
 * Given an object with number values, calulate and return
 * the sum of all values.
 */
export const addValues = <T>(obj: T): number => {
    return _.sum(_.toArray(obj));
};
